import Vue from 'vue'
import Router from 'vue-router'
import home from './views/home.vue'
import about from "@/views/about.vue";
import layout from "@/views/layout.vue";
import products from "@/views/products.vue";
import solutions from "@/views/solution.vue";
import solutions2 from "@/views/solution2.vue";
import contact from "@/views/contact.vue";
import cases from "@/views/cases.vue";

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/', component: layout,
            redirect: 'home',
            children: [
                {
                    path: '/home',
                    name: 'home',
                    component: home
                },
                {
                    path: '/about',
                    name: 'about',
                    component: about
                },
                {
                    path: '/products',
                    name: 'products',
                    component: products
                },
                {
                    path: '/solutions',
                    name: 'solutions',
                    component: solutions
                },
                {
                    path: '/solutions2',
                    name: 'solutions2',
                    component: solutions2
                },
                {
                    path: '/cases',
                    name: 'cases',
                    component: cases
                }, {
                    path: '/contact',
                    name: 'contact',
                    component: contact
                },

            ]
        },
        // 其他路由...
    ]
})
